import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import TranslatedCopy from '../../../intl/translated-copy';
import cx from 'classnames';
import useWizard from '../wizard/useWizard';
import { UpdateDocumentNumbers, UpdateGDocumentNumbers } from '../../../../redux/actions';
import { connect } from 'react-redux';
import { formatAmountWithDecimals } from '../../../../cms-wrapper/utils';
import Tooltip from '../tooltip';

export const RefundBreakdown = ({
  breakpointNewDesign,
  confirmation = false,
  dispatch,
  fulfillRefundData,
  stateStoreFront,
  storefront,
}) => {
  const { quotationsToRender, GTicketList } = useWizard();

  const showPenaltyTotals = storefront === 'es-gt' || storefront === 'es-ni' || storefront === 'es-cr';
  const isSmall = breakpointNewDesign === 'small';
  let totalFulFill = 0;
  const currencyOfRefund = quotationsToRender?.[0]?.quoteItemAmount?.currencyCode;
  const numberOfDecimalsBE = stateStoreFront?.numberOfDecimalsBE != null ? stateStoreFront.numberOfDecimalsBE : 0;
  const formatAmount = (amount) => `$${ formatAmountWithDecimals(amount, numberOfDecimalsBE) }`;

  // Se hizo maquetado, actualmente no existe informacion real para asignar esto
  const showPoints = false;

  const passengerInfoClass = cx({
    'RefundBreakdown-section-optionTile-passengerInfo': true,
    'noPoints': !showPoints,
  });

  const confirmationClass = cx({
    'RefundBreakdown-section-confirmationTile': true,
    'noPoints': !showPoints,
  });

  const [totalQuote, setTotalQuote] = useState(0);
  const [penaltyCharge, setPenaltyCharge] = useState(0);
  const [priceBeforePenalty, setPriceBeforePenalty] = useState(0);
  const [penaltyTax, setPenaltyTax] = useState(0);

  let penaltyChargeFulfill = 0;
  let priceBeforePenaltyFulfill = 0;
  let penaltyTaxFulfill = 0;

  if (confirmation) {
    (fulfillRefundData?.refunds).map(refund => {
      if (refund?.penaltyInfo?.penaltyApplies) {
        penaltyChargeFulfill += parseFloat(refund?.penaltyInfo?.changeFeeAmount?.amount, 10);
        priceBeforePenaltyFulfill += parseFloat(refund?.penaltyInfo?.totalRefundAmountAfterPenalty?.amount, 10) + parseFloat(refund?.penaltyInfo?.changeFeeAmount?.amount, 10);
        penaltyTaxFulfill += parseFloat(refund?.penaltyInfo?.feeTaxes?.[0]?.taxAmount?.amount, 10);
        totalFulFill += parseFloat(refund?.penaltyInfo?.totalRefundAmountAfterPenalty?.amount, 10);
      } else {
        const refundPaxAmount = refund?.refundedItemAmount?.reduce((refundPax, amount) => (refundPax + amount?.dAmount), 0);
        totalFulFill += refundPaxAmount;
        priceBeforePenaltyFulfill += refundPaxAmount;
      }
    });
  }

  const handleClickOnPassengerList = () => {
    const passengersSelected = document.querySelectorAll('input[name="passengerOption"]:checked');
    const documentNumbers = [];
    let totalQuotePrice = 0;

    let penaltyCharge = 0;
    let priceBeforePenalty = 0;
    let penaltyTax = 0;

    passengersSelected.forEach(passengerSelected => {
      const documentNumber = passengerSelected?.id;
      const quotation = quotationsToRender.find(quotation => quotation.documentNumber === documentNumber);
      if (quotation?.penaltyInfo?.penaltyApplies) {
        penaltyCharge += parseFloat(quotation?.penaltyInfo?.changeFeeAmount?.amount, 10);
        priceBeforePenalty += parseFloat(quotation?.penaltyInfo?.totalRefundAmountAfterPenalty?.amount, 10) + parseFloat(quotation?.penaltyInfo?.changeFeeAmount?.amount, 10);
        penaltyTax += parseFloat(quotation?.penaltyInfo?.feeTaxes?.[0]?.taxAmount?.amount, 10);
        totalQuotePrice += parseFloat(quotation?.penaltyInfo?.totalRefundAmountAfterPenalty?.amount, 10);
      } else {
        totalQuotePrice += parseFloat(passengerSelected?.value, 10);
        priceBeforePenalty += parseFloat(passengerSelected?.value, 10);
      }

      documentNumbers.push({ 'documentNumber': passengerSelected?.id });
    });

    setTotalQuote(totalQuotePrice);    
    setPenaltyCharge(penaltyCharge);
    setPriceBeforePenalty(priceBeforePenalty);
    setPenaltyTax(penaltyTax);

    dispatch(UpdateDocumentNumbers(documentNumbers));
  };

  useEffect(() => {
    if (GTicketList.length > 0) {
      dispatch(UpdateGDocumentNumbers(GTicketList));
    }
  }, []);

  const refundTotal = () => {
    return (
      <>
        { showPoints &&
          <div className='RefundBreakdown-totalPointsDetailsWrapper'>
            <TranslatedCopy copyID='MYB_TOTAL_IN_POINTS' className='RefundBreakdown-totalAmountDetailsWrapper--title' />
            <p className='RefundBreakdown-totalPointsDetailsWrapper-points'>{ '0 ' }
              <TranslatedCopy
                tagName='span'
                copyID='MYB_POINTS_SELECT'
                className='RefundBreakdown-totalPointsDetailsWrapper-pointsText'
              />
            </p>
          </div>
        }
        { showPenaltyTotals &&
          <>
            <div className='RefundBreakdown-totalAmountDetailsWrapper subtotalSection'>
              <TranslatedCopy
                className='RefundBreakdown-totalAmountDetailsWrapper--title'
                copyID='MYB_FG_SUBTOTAL'
                tagName='p'
              />
              <div className='RefundBreakdown-totalAmountDetailsWrapper-totalAmount'>
                <p className='RefundBreakdown-totalAmountDetailsWrapper-totalAmount--value'>
                  { formatAmount(confirmation ? priceBeforePenaltyFulfill : priceBeforePenalty) }
                </p>
                <p className='RefundBreakdown-totalAmountDetailsWrapper-totalAmount--currency'>{ currencyOfRefund }</p>
              </div>
            </div>
            <div className='RefundBreakdown-totalAmountPenaltyWrapper'>
              <div className='RefundBreakdown-totalAmountPenaltyWrapper-tooltipSection'>
                <TranslatedCopy
                  className='RefundBreakdown-totalAmountPenaltyWrapper--penaltyTitle'
                  copyID='MYB_REFUND_PENALTY'
                  tagName='p'
                />
                <Tooltip
                  className='RefundBreakdown-totalAmountPenaltyWrapper--tooltip'
                  copyID='MYB_REQUESTED_REFUND_APPLIES_PENALTY'
                  labelID='refundPenaltyTooltip'
                  tooltipID='tooltiptext'
                  position={ {
                    'small': 'bottom',
                    'medium': 'bottom',
                    'medium-high': 'bottom',
                    'large': 'bottom',
                  } }
                />
              </div>
              <div className='RefundBreakdown-totalAmountPenaltyWrapper-totalAmount'>
                <p className='RefundBreakdown-totalAmountPenaltyWrapper-totalAmount--penaltyValue'>
                  - { formatAmount(confirmation ? penaltyChargeFulfill : penaltyCharge) }
                </p>
              </div>
            </div>
            <div className='RefundBreakdown-totalAmountPenaltyWrapper'>
              <TranslatedCopy
                className='RefundBreakdown-totalAmountPenaltyWrapper--penaltyTitle'
                copyID='MYB_REFUND_TAX_PENALTY'
                tagName='p'
              />
              <div className='RefundBreakdown-totalAmountPenaltyWrapper-totalAmount'>
                <p className='RefundBreakdown-totalAmountPenaltyWrapper-totalAmount--penaltyValue'>
                  { formatAmount(confirmation ? penaltyTaxFulfill : penaltyTax) }
                </p>
              </div>
            </div>
          </>
        }
        <div className='RefundBreakdown-totalAmountDetailsWrapper'>
          <TranslatedCopy
            className='RefundBreakdown-totalAmountDetailsWrapper--title'
            copyID='MYB_TOTAL_IN_MONEY'
            tagName='p'
          />
          <div className='RefundBreakdown-totalAmountDetailsWrapper-totalAmount'>
            <p className='RefundBreakdown-totalAmountDetailsWrapper-totalAmount--value'>
              { formatAmount(confirmation ? totalFulFill : totalQuote) }
            </p>
            <p className='RefundBreakdown-totalAmountDetailsWrapper-totalAmount--currency'>{ currencyOfRefund }</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className='RefundBreakdown-section'>
        { confirmation ?
          <>
            { (fulfillRefundData?.refunds || []).map((fulfill) => {
              const refundPax = fulfill?.refundedItemAmount?.reduce((refundPax, amount) => (refundPax + amount?.dAmount), 0);

              return (
                <Fragment key={ fulfill?.passenger?.nameNumber }>
                  { fulfill?.refunded &&
                    <div className={ confirmationClass }>
                      { isSmall ?
                        <p className='RefundBreakdown-section-confirmationTile--title'>{ `${fulfill?.passenger?.name.split('/')[0].substr(0, 3)}${fulfill?.passenger?.name.split('/')[0].length > 3 ? '.' : ''} / ${fulfill?.passenger?.name.split('/')[1]}` }</p>
                        :
                        <p className='RefundBreakdown-section-confirmationTile--title'>{ `${fulfill?.passenger?.name.split('/')[0]} / ${fulfill?.passenger?.name.split('/')[1]}` }</p>
                      }
                      <div className='RefundBreakdown-section-confirmationTile-ptosAndCash'>
                        { showPoints &&
                          <p className='RefundBreakdown-section-confirmationTile-ptosAndCash--totalValue'>0 <TranslatedCopy tagName='span' copyID='MYB_POINTS_SELECT' /> + </p>
                        }
                        <p className='RefundBreakdown-section-confirmationTile-ptosAndCash--totalValue'>
                          { formatAmount(refundPax) }
                        </p>
                      </div>
                    </div>
                  }
                </Fragment>
              );
            })
            }
          </>
          :
          <>
            { (quotationsToRender || []).map((quotation) => {
              const nameAbbreviated = `${quotation?.passenger?.name.split('/')[0].substr(0, 3)}${quotation?.passenger?.name.split('/')[0].length > 3 ? '.' : ''} / ${quotation?.passenger?.name.split('/')[1]}`;
              const nameWithFormat = `${quotation?.passenger?.name.split('/')[0]} / ${quotation?.passenger?.name.split('/')[1]}`;

              const name = isSmall ? nameAbbreviated : nameWithFormat;

              return (
                <div className='RefundBreakdown-section-optionTile' key={ quotation?.passenger?.nameNumber }>
                  <label className='RefundBreakdown-containerRadioFooter'>
                    <input
                      id={ quotation?.documentNumber }
                      name='passengerOption'
                      onClick={ () => handleClickOnPassengerList() }
                      type='checkbox'
                      value={ quotation?.quoteItemAmount?.dAmount }
                    />
                    <span className='RefundBreakdown-checkmarkPassenger' />
                  </label>
                  <div className={ passengerInfoClass }>
                    <p className='RefundBreakdown-section-optionTile-passengerInfo--title'>{ name }</p>
                    <div className='RefundBreakdown-section-optionTile-passengerInfo-ptosAndCash'>
                      { showPoints &&
                        <p className='RefundBreakdown-section-optionTile-passengerInfo-ptosAndCash--totalValue'>{ '0 ' }<TranslatedCopy tagName='span' copyID='MYB_POINTS_SELECT' /> + </p>
                      }
                      <p className='RefundBreakdown-section-optionTile-passengerInfo-ptosAndCash--totalValue'>
                        { formatAmount(quotation?.quoteItemAmount?.sAmount) }
                      </p>
                    </div>
                  </div>
                </div>
              );
            })
            }
          </>
        }
        { breakpointNewDesign !== 'small' &&
          <>
            { refundTotal() }
          </>
        }
      </div>
      { isSmall &&
        <>
          { refundTotal() }
        </>
      }
    </>
  );
};

RefundBreakdown.propTypes = {
  breakpointNewDesign: PropTypes.string,
  confirmation: PropTypes.bool,
  fulfillRefundData: PropTypes.object,
};

const mapStateToProps = (state) => ({
  fulfillRefundData: state.fulfillRefund.fulfillRefundData,
  stateStoreFront: state.Manage.stateStoreFront,
  storefront: state.Manage.storefront,
});

export default connect(mapStateToProps)(RefundBreakdown);